import { EntityPagedResult, BaseEntity } from "@bndes/bndes-angular-utils";

export abstract class BaseState<T>
{

}